export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11481.92f67055.jpg";